module.exports = __webpack_public_path__ + "img/icon-success.8fbb0e4a.png";